import React from 'react';
import _ from 'lodash';

import {
  LeaseApplicationStatusName,
  LeaseApplicationStep,
  LeaseApplicationStepNameName,
  useSmartPayLeaseApplicationSectionQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';
import { ApiRequestTable } from 'modules';



export interface IData {
  showManualOverrideButton: boolean;
  leaseApplicationId: string;
  orderId: string;
  apiRequests: ApiRequestTable.IApiRequest[];
}


export function useQuery(orderId: string) {
  const queryTuple = useSmartPayLeaseApplicationSectionQuery({
    variables: {
      orderId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const leaseApplication = queryTuple.data?.order?.smartPayLeaseApplication;
    const appNumber = leaseApplication?.applicationNumber ?? '';
    const completedFraudCheck = __stepsAreInStatus(['fraudCheck'], leaseApplication?.steps ?? [], 'complete');
    const originationIncomplete = __stepsAreInStatus(['lease'], leaseApplication?.steps ?? [], 'incomplete');
    const activationIncomplete = __stepsAreInStatus(['activated'], leaseApplication?.steps ?? [], 'incomplete');

    const data: IData = {
      orderId: queryTuple.data?.order?.id ?? '',
      showManualOverrideButton: completedFraudCheck && (originationIncomplete || activationIncomplete),
      leaseApplicationId: queryTuple.data?.order?.smartPayLeaseApplication?.id ?? '',
      apiRequests: _.map(queryTuple.data?.order?.smartPayLeaseApplication?.apiRequests.nodes ?? [], (node): ApiRequestTable.IApiRequest => {
        let applicationNumberMatchesOrLeaseSuccess = true;
        if (_.includes(node.url, 'lookup')) {
          applicationNumberMatchesOrLeaseSuccess = node.responseBody.application_number == appNumber;
        } else if (_.includes(node.url, 'lease')) {
          applicationNumberMatchesOrLeaseSuccess = node.responseBody.success === true;
        }

        return {
          id: node.id,
          metaCreated: DateTime.fromISO(node.metaCreated),
          requestBody: node.requestBody,
          responseBody: node.responseBody,
          url: node.url,
          method: node.method,
          statusCode: node.httpStatusCode,
          isOK: applicationNumberMatchesOrLeaseSuccess && node.httpStatusCode === 200
        };
      })
    };

    return {
      ...queryTuple,
      data
    };
  }, [queryTuple]);


  return wrappedTuple;
}



function __stepsAreInStatus(stepsToCheck: LeaseApplicationStepNameName[], steps: LeaseApplicationStep[], statusName: LeaseApplicationStatusName) {
  return _.every(stepsToCheck, stepToCheck => {
    // Find step in provided status or not applicable.
    const step = _.find(steps, step => step.name.name === stepToCheck);
    return step?.status.name === statusName || step?.status.name === 'notApplicable';
  });
}
